import { BaseService } from '@services/BaseService'

const resource = 'hr/condition'

class ConditionService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const conditionService = new ConditionService()
